module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "p_heading_",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Buried Secrets")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_vm._v("By John R. Petrie")]), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_vm._v("A Timothy and Wyatt Mystery")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("The son of an alcoholic mother, Wyatt Courtland skips school to work construction to help the family survive. When he finds a lockbox containing a series of articles about Bobby LaFleur, a student who went missing four years ago, he enlists the help of sheriff’s son Timothy Mitchell to learn what happened to Bobby.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Timothy wants to go into law enforcement, even if it’s against his father’s wishes. He figures solving this case will convince his dad he can handle police work, but as he digs deeper, he uncovers a string of missing boys—and the truth about Wyatt’s desire to find out what truly happened to Bobby. As the two grow closer, they realize the mystery is far more sinister than they imagined—and it’s a secret someone is willing to kill to protect.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98d33330","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OPS/section0002.vue
// module id = 60
// module chunks = 0